<template>
  <div>
    <h1 v-if="obData.messages" class="def-header-2">{{ obData.messages.title }}</h1>
    <div class="page-news__grid">
      <NewsCard
        v-for="item in obData.items"
        :key="item.id"
        :result="item"
        :messages="obData.messages"
      />
    </div>
    <Pagination :result="obData.pagination" @change="getPage" @addMore="addMore" />
  </div>
</template>

<script>
import NewsCard from '@components/News/NewsCard/NewsCard.vue';
import { mapMutations } from 'vuex';
import Pagination from '@components/bootstrap/Pagination.vue';

export default {
  name: 'News',
  components: { Pagination, NewsCard },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      obData: this.result,
    };
  },
  methods: {
    ...mapMutations({
      loaderStart: 'global/loaderStart',
      loaderStop: 'global/loaderStop',
    }),
    /**
     * Тут происходит склеивание данных успешного ответа Ajax запроса
     */
    compareResponse(response) {
      const { data } = response;

      if (this.debug) {
        console.log('ajaxResponse', response);
      }

      for (const key in data.items) {
        this.obData.items.push(data.items[key]);
      }

      this.obData.pagination = data.pagination;
    },
    /**
     * Имитация перехода на нужную страницу
     */
    replaceResponse(response) {
      this.obData = response.data;
    },
    /**
     * Метод по которому происходит Ajax загрузка данных (добавление)
     */
    async addMore() {
      try {
        this.loaderStart();

        if (this.obData.pagination.pageCount > this.obData.pagination.pageNumber) {
          const response = await axios.get(window.location.href, {
            params: {
              api: 'y',
              [this.obData.pagination.pagingKey]: ++this.obData.pagination.pageNumber,
            },
          });
          this.compareResponse(response);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loaderStop();
      }
    },
    /**
     * Метод по которому происходит Ajax переход на нужную страницу
     * @param numb
     */
    async getPage(url) {
      try {
        this.loaderStart();
        const response = await axios.get(url, {
          params: {
            api: 'y',
          },
        });
        this.replaceResponse(response);
      } catch (err) {
        console.error(err);
      } finally {
        this.loaderStop();
      }
    },
  },
};
</script>

<style lang="scss">
.page-news {
  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2px;
    @include point-lg {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 40px;
      & > *:first-child {
        grid-column-start: 1;
        grid-column-end: 3;
        .def-title-3 {
          font-size: rem(32);
        }
        .news-card__text {
          font-size: rem(24);
          min-height: 56px;
          max-width: 850px;
        }
        .news-card__date {
          font-size: rem(16);
        }
      }
    }
  }
}
</style>
